module.exports = __webpack_public_path__ + "img/lightbulb.3c0c913b.svg";